import { render } from "./AdminCalendar.vue?vue&type=template&id=65bb9fb2"
import script from "./AdminCalendar.vue?vue&type=script&lang=js"
export * from "./AdminCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__